import { Component, OnInit } from '@angular/core';
import { WebpageService } from '../../@core/services/webpage.service';
import { ActivatedRoute } from '@angular/router';
import { ApiProvider } from '../../@core/providers/api.provider';
import { Title, Meta } from '@angular/platform-browser';
import { WebpagesService } from '../../@core/services/webpages.service';
import { AuthenticationService } from '../../@core/services/authentication.service';

@Component({
  selector: 'standart',
  templateUrl: './standart.component.html',
  styleUrls: ['./standart.component.scss']
})
export class StandartComponent implements OnInit {

  public webPageID:number = 0;
  constructor(
    public apiProvider: ApiProvider,
    private route: ActivatedRoute,
    public _webpageService: WebpageService,    
    public _webpagesService: WebpagesService,  
    public authenticationService: AuthenticationService,  
    ) {
    this.route.paramMap.subscribe(params => {
      if(params.get("WebPageID") != null){
          this.webPageID = Number(params.get("WebPageID"));
          this._webpageService.initialiseWebPage(this.webPageID, this.authenticationService.currentUserValue.language);
        }
      }
    )
   }

  ngOnInit() {    
  }

}
